import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { AttemptFormValues } from 'src/models/Attempt.model';
import Attempt from '../Layouts/AttemptForm';
import { useGetAttemptByIdQuery, useUpdateAttemptByIdMutation } from 'src/services/AttemptService';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';

type Props = {
  onClose: () => void;
  selectedAttemptId: string
};

const EditAttemptWrapper = ({ onClose, selectedAttemptId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetAttemptByIdQuery(selectedAttemptId);
  const [updateCourseTypeById] = useUpdateAttemptByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);



  const initialValues: AttemptFormValues = {
    attempt: items?.attempt || '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    attempt: string().required('Please enter attempt'),
  });

  // Handle Submit
  const handleSubmit = (
    values: AttemptFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AttemptFormValues>
  ) => {
    updateCourseTypeById({ id: selectedAttemptId, body: values }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  }

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Attempt formikProps={formikProps} onClose={onClose} formType="EDIT" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};
export default EditAttemptWrapper;